import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const getCity = async (params: object) => {
  // @ts-expect-error
  return await GET({ url: params.api || Api.getCity, params, showError: false })
}
